import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to manage focus on route changes for accessibility
 * Moves focus to the top of the main content when navigating
 */
export const useRouteFocus = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Skip if it's just a hash change (internal link)
    if (window.location.hash) return;

    const mainContent = document.getElementById('main-content');
    
    if (mainContent) {
      // Small timeout to ensure DOM is ready
      setTimeout(() => {
        mainContent.focus();
        // Remove outline for mouse users, keep for keyboard
        mainContent.style.outline = 'none';
      }, 100);
    }
  }, [pathname]);
};

export default useRouteFocus;